import React, { forwardRef, memo, useState } from "react";

import bellSvg from "../../common/icons/svg/bell.svg";
import bellSolidSvg from "../../common/icons/svg/bell-solid.svg";
// import bellAlert from "../../common/icons/svg/bell-alert.svg";
import favoriteSvg from "../../common/icons/svg/favorite.svg";
import favoriteSelectedSvg from "../../common/icons/svg/favorite-selected.svg";
import rightArrowSvgSvg from "../../common/icons/svg/right-arrow-solid.svg";
// import blackDownArrow from "../../common/icons/svg/black-down-arrow.svg";
import whiteUpArrow from "../../common/icons/svg/white-up-arrow.svg";
import whiteDownArrow from "../../common/icons/svg/white-down-arrow.svg";
import humanSvg from "../../common/icons/svg/human.svg";
import "./BedCardNew.scss";
import { ADD, MODAL_ITEMS, REMOVE, VIEW_TYPES } from "../../common/constant/common-constants";
import moment from "moment";

const BedCardNew = forwardRef((props, ref) => {

    const BED_CARD_VITALS = {
        MONITOR: [{
            "name": "RR",
            "label": "RR"
        }, {
            "name": "HR",
            "label": "HR"
        }, {
            "name": "SPO2",
            "label": "SPO2"
        }, {
            "name": "TEMP",
            "label": "TEMP"
        }, {
            "name": "BPLOW",
            "label": "BP"
        }],
        VENTILATOR: [{
            "name": "MVE",
            "label": "MVe"
        }, {
            "name": "PRESSURE",
            "label": "PIP"
        }, {
            "name": "FIO2",
            "label": "FIO2"
        }, {
            "name": "PEEP",
            "label": "PEEP"
        }, {
            "name": "TIDALVOLUME",
            "label": "VTe"
        }]
    }

    const [showMoreAlarms, setShowMoreAlarms] = useState(false);
    const [showNotificationDetails, setShowNotificationDetails] = useState(false);

    const handleNotificationIconClick = (event) => {

        event.stopPropagation();
        setShowNotificationDetails(!showNotificationDetails);
    }

    const handleShowMoreAlarmsClick = (event) => {

        event.stopPropagation();
        setShowMoreAlarms(!showMoreAlarms);
    }

    // TODO: for ui porpose only, need to remove
    const getAlarmPriorityClass = (alarmData) => {

        // let id = bedId && bedId.toString();

        switch (alarmData.priority) {
            case "HIGH":
                return "high-priority";
            case "MEDIUM":
                return "medium-priority";
            case "LOW":
                return "low-priority";
            default:
                return "low-priority";
        }
    }

    const handlePatientCTA = (type) => {
        props.handlePatientCTA(type);
    }

    // if (props.data === null || props.bedId === null) {
    //     return <div className="empty" ref={ref} key={"test-"}></div>;
    // } else {
    return (
        <div className="bed-card-container" ref={ref} key={"key-" + props.bedId}>
            <div className={props.isSelected ? "bed-card selected-bed" : "bed-card"} onClick={() => props.handleBedClick(props.bedId)}>
                <div className="bed-patient-details" onClick={() => props.handleBedHeaderClick()}>
                    <div className="bed-header">
                        <div className="bed-number">
                            Bed: {props.bedId}
                        </div>
                        {props.alarmData && props.alarmData.length > 0 &&
                            <div
                                className={`alarm-container ${getAlarmPriorityClass(props.alarmData[0])}`}
                                onClick={(event) => handleShowMoreAlarmsClick(event)}
                            >
                                <div className="top-alarm-container">
                                    {`${props.alarmData[0].name}: ${props.alarmData[0].value}`}
                                </div>
                                <div className="alarm-number-container">
                                    {props.alarmData.length}
                                    {!showMoreAlarms && <img src={whiteDownArrow} className="arrow-icon" alt="white down arrow" />}
                                    {showMoreAlarms && <img src={whiteUpArrow} className="arrow-icon" alt="white up arrow" />}
                                </div>
                                {showMoreAlarms && <div className="more-alarm-container">
                                    {
                                        props.alarmData.map((alarm, count) => {
                                            if (count === 0 || count > 5) return;
                                            return (
                                                <div className="alarm more-alarm" key={count}>
                                                    {`${alarm.name}: ${alarm.value}`}
                                                    <span className="alarm-time">{alarm.time && moment(alarm.time).format("HH:mm:ss")}</span>
                                                </div>);
                                        })
                                    }
                                    <div className="see-all-container" onClick={() => props.handleAlarmMoreClick()}>
                                        See all
                                    </div>
                                </div>}
                            </div>}
                        {/* <div className={getEwsScoreClassName(props.data.data.ewsScore)}>
                                {(props.data.data && props.data.data.ewsScore) || "No Risk"}
                            </div> */}
                        <div className="notification-container bell-container">
                            {false && <div className="icon-container bell-icon">
                                <img src={bellSvg} alt="notification icon" onClick={() => props.handleNotificationClick(props.bedId)} />
                            </div>}
                            {true && <div className="icon-container bell-icon">
                                <img
                                    src={bellSolidSvg}
                                    alt="notification icon"
                                    onClick={(event) => handleNotificationIconClick(event)}
                                />
                            </div>}
                            {showNotificationDetails && <div className="notification-details">
                                <div className="notification">
                                    <div className="notification-name">
                                        Tab Dolo given at 16:00
                                    </div>
                                    <div className="ack-button">
                                        Acknowledge
                                    </div>
                                </div>
                                <div className="notification">
                                    <div className="notification-name">
                                        Tab Dolo given at 16:00
                                    </div>
                                    <div className="ack-button">
                                        Acknowledge
                                    </div>
                                </div>
                                <div className="notification">
                                    <div className="notification-name">
                                        Tab Dolo given at 16:00
                                    </div>
                                    <div className="ack-button">
                                        Acknowledge
                                    </div>
                                </div>
                            </div>}
                        </div>
                        {!props.isFavorite && <div className="icon-container favorite-icon">
                            <img src={favoriteSvg} alt="notification icon" onClick={(event) => props.handleFavoriteClick(event, ADD, props.bedId)} />
                        </div>}
                        {props.isFavorite && <div className="icon-container favorite-icon">
                            <img src={favoriteSelectedSvg} alt="favorite icon" onClick={(event) => props.handleFavoriteClick(event, REMOVE, props.bedId)} />
                        </div>}
                    </div>
                    <div className="patient-details">
                        <div className="patient-name">
                            {(props.patientData && props.patientData.name) || 'Dummy Name'}
                        </div>
                        <div className="pipe">
                            |
                        </div>
                        <div className="patient-age">
                            {(props.patientData && props.patientData.age) || 'Age'}
                        </div>
                        <div className="pipe">
                            |
                        </div>
                        <div className="patient-gender">
                            {(props.patientData && props.patientData.gender) || 'Gender'}
                        </div>
                        <div className="pipe">
                            |
                        </div>
                        <div className="patient-uhid">
                            {(props.patientData && props.patientData.uhid) ?
                                (`UHID : ${props.patientData.uhid}`) : ('UHID : -')}
                        </div>
                    </div>
                </div>
                <hr className="hr-line" />
                <div className="device-details">
                    <div className="device monitor">
                        <div className="device-name">
                            Patient Monitor
                        </div>
                        <div className="device-data">

                            {BED_CARD_VITALS.MONITOR.map((vital) => {
                                let vitalData = props.monitorData && props.monitorData.vitals.filter(
                                    (mvital) => mvital.name && mvital.name.toUpperCase() === vital.name
                                )[0];

                                let status = vitalData && vitalData.data[0] && vitalData.data[0].status;

                                return (<div className={`vital-data-detail ${vital.name.toLowerCase()}`} key={vital.name}>
                                    <div className="vital-name">
                                        {vital.label}
                                    </div>
                                    <div className={status ? `${status.toLowerCase()} vital-data` : 'vital-data'}>
                                        {(vitalData && vitalData.data[0] && vitalData.data[0].value) || '-'}
                                        {vitalData && vitalData.unit && <span className="unit">{vitalData.unit || 'unit'}</span>}
                                    </div>
                                </div>)
                            })}
                        </div>
                    </div>
                    <div className="device ventilator">
                        <div className="device-heading">
                            <div className="device-name">
                                Ventilator
                            </div>
                            <div className="device-mode">
                                <img src={humanSvg} className="human-icon" alt="human icon" />
                                <span className="ventilator-mode">VC-CMV</span>
                            </div>
                        </div>

                        <div className="device-data">
                            {BED_CARD_VITALS.VENTILATOR.map((vital) => {
                                let vitalData = props.ventilatorData && props.ventilatorData.vitals.filter(
                                    (vVital) => vVital.name && vVital.name.toUpperCase() === vital.name
                                )[0];

                                let status = vitalData && vitalData.data[0] && vitalData.data[0].status;
                                return (
                                    <div className={`vital-data-detail ${vital.name.replace(/[\W_]+/g, "").toLowerCase()}`} key={vital.name}>
                                        <div className="vital-name">
                                            {vital.label}
                                        </div>
                                        <div className={status ? `${status.toLowerCase()} vital-data` : 'vital-data'} >
                                            {(vitalData && vitalData.data[0] && vitalData.data[0].value) || '-'}
                                            {vitalData && vitalData.unit && <span className="unit">{vitalData.unit || ''}</span>}
                                        </div>
                                    </div>)
                            })}
                        </div>
                    </div>
                    <div className="patient-cta">
                        <div className="charting cta-button" onClick={() => handlePatientCTA(MODAL_ITEMS.CHARTING)}>Charting</div>
                        <div className="nurse-notes cta-button" onClick={() => handlePatientCTA(MODAL_ITEMS.NURSE_NOTES)}>Nurse Notes</div>
                        <div className="doctor-notes cta-button" onClick={() => handlePatientCTA(MODAL_ITEMS.DOCTOR_NOTES)}>Doctor Notes</div>
                        <div className="Prescription cta-button" onClick={() => handlePatientCTA(MODAL_ITEMS.PRESCRIPTION)}>Prescription</div>
                    </div>
                </div>
            </div>
            {props.isSelected && (props.viewType === VIEW_TYPES.LIST_VIEW) && <div className="arrow-container">
                <img src={rightArrowSvgSvg} alt="arrow icon" onClick={() => console.log("notification icon clicked")} />
            </div>}
        </div>
    );
    // }
})

export default memo(BedCardNew);